import { useState } from "react";

/**
 * Bouton qui ouvre une affiche (goûts, toppers, etc.) en grand dans une fenêtre légère.
 * Usage : <GuidePoster image="/images/guides/guide-gouts.jpg" label="Voir le guide des goûts" />
 */
const GuidePoster = ({ image, label }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex items-center gap-2 text-sm text-primary font-medium mb-3 hover:underline"
      >
        🖼️ {label}
      </button>

      {open && (
        <div
          onClick={() => setOpen(false)}
          className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 cursor-zoom-out"
        >
          <img
            src={image}
            alt={label}
            onClick={(e) => e.stopPropagation()}
            className="max-w-full max-h-full rounded-xl shadow-2xl cursor-default"
          />
          <button
            onClick={() => setOpen(false)}
            className="absolute top-4 right-4 text-white text-3xl leading-none w-10 h-10 flex items-center justify-center rounded-full bg-black/40 hover:bg-black/60"
          >
            ×
          </button>
        </div>
      )}
    </>
  );
};

export default GuidePoster;